<template>
  <div class="reset-wrapper">
    <div class="reset" v-if="!isPassUpdated">
      <h1 style="color: rgb(72, 87, 106);"><b>Reset password</b></h1>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="top">
        <el-form-item label="Password" prop="pass">
          <el-input :type="inputypePrng" @keyup.enter="submitForm('ruleForm')" v-model="ruleForm.pass" auto-complete="off">
            <el-button slot="append" @click="showpassPrng" class="btn-eye">
              <div :style="{ color: icolorPrng }">
                <eye-off-icon v-if="inputypePrng === 'password'"  width=16></eye-off-icon>
                <eye-icon v-if="inputypePrng === 'text'" width=16></eye-icon>
              </div>
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="confirmPass">
          <el-input :type="inputypePrng" @keyup.enter="submitForm('ruleForm')" v-model="ruleForm.confirmPass" auto-complete="off">
            <el-button slot="append" @click="showpassPrng" class="btn-eye">
              <div :style="{ color: icolorPrng }">
                <eye-off-icon v-if="inputypePrng === 'password'"  width=16></eye-off-icon>
                <eye-icon v-if="inputypePrng === 'text'" width=16></eye-icon>
              </div>
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="isSubmitButtonLoading">Submit</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reset" v-if="isPassUpdated">
      <h1 style="color: rgb(72, 87, 106);"><b>Password updated</b></h1>
      <p style="font-size: 1.6em;">Sweet! Your new password has now been set and you are logged in. Go to <a @click="goToDashboard">Dashboard</a></p>
    </div>
  </div>
</template>

<script>
import { EyeOffIcon, EyeIcon } from 'vue-feather-icons';
import luxtagApi from '../API/index';
// import EventBus from '../Buss/EventBus';
import nem from '../../static/js/index';

export default {
  data() {
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input your password again'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('Password does not match'));
      } else {
        callback();
      }
    };
    return {
      isPassUpdated: false,
      inputypePrng: 'password',
      isSubmitButtonLoading: false,
      iconPrng: 'eye-slash',
      icolorPrng: '#13CE66',
      ruleForm: {
        pass: '',
        confirmPass: '',
        passPhrase: '',
      },
      rules: {
        pass: [
          { required: true, message: 'Please input your password', trigger: 'blur' },
          { min: 6, message: 'The password should be at least 6 charachters', trigger: 'blur' },
        ],
        confirmPass: [
          { required: true, validator: validateConfirmPass, trigger: 'blur, change' },
        ],
      },
    };
  },
  methods: {
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    showpassPrng: function () {
      if (this.inputypePrng === 'password') {
        this.inputypePrng = 'text';
        this.iconPrng = 'eye';
        this.icolorPrng = '#FF4949';
      } else if (this.inputypePrng === 'text') {
        this.inputypePrng = 'password';
        this.iconPrng = 'eye-slash';
        this.icolorPrng = '#13CE66';
      }
    },
    submitForm(formName) {
      this.isSubmitButtonLoading = true;
      const that = this; // we preserve the this scope (to work inside the nem functions
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // POST reset password request
          const resetToken = that.$route.params.token;
          luxtagApi.user.resetPw(resetToken, that.ruleForm.pass)
          .then((response) => {
            console.log(response);
            // success reset password
            // EventBus.$emit('loading-start');

            // check if there is any wallet for this account
            for (let i = 0, iLen = that.accounts.length; i < iLen; i += 1) {
              if (that.accounts[i].name === response.data.user.email) {
                that.accountIndex = i;
                break;
              }
            }

            const pk = nem.crypto.helpers.derivePassSha(response.data.user.passphrase, 6000).priv;
            // get wallet to decrypt
            let wallet;

            // if (that.accountIndex !== null) {
            //   // wallet is exist on local storage for this account
            //   wallet = that.accounts[that.accountIndex];
            // } else {
            //   // there is no wallet in local storage so create one
            //   wallet = nem.model.wallet
            //   .importPrivateKey(
            //     response.data.user.email,
            //     response.data.user.passphrase,
            //     pk,
            //     nem.model.network.data.mainnet.id);

            //   // commit the wallet to the localStorage
            //   that.$store.dispatch('storeAccount', wallet);

            //   // get the index from the new wallet
            //   that.accountIndex = that.$store.getters.getAccounts.length - 1;
            // }
            wallet = nem.model.wallet
              .importPrivateKey(
                response.data.user.email,
                response.data.user.passphrase,
                pk,
                nem.model.network.data.mainnet.id);

            // commit the wallet to the localStorage
            that.$store.dispatch('storeAccount', wallet);

            // get the index from the new wallet
            that.accountIndex = that.$store.getters.getAccounts.length - 1;

            // choose the first account of wallet
            wallet = wallet.accounts[0];

            // we commit name and pass to the store
            this.$store.commit('PUSH_WALLETNAME',
            that.accounts[that.accountIndex].name);
            const keyPair = nem.crypto.keyPair.create(pk);
            this.$store.commit('PUSH_PP', keyPair.publicKey.toString());
            this.$store.commit('PUSH_WALLET', wallet); // commit the wallet to the store
            this.$store.commit('PUSH_INDEX', that.accountIndex);
            this.$store.commit('PUSH_ADDRESS', wallet.address);
            this.$store.commit('PUSH_TOKEN', response.data.jwt);
            // EventBus.$emit('login', {
            //   login: true,
            //   index: that.$store.getters.getCurrentIndex,
            //   PP: that.$store.getters.getPP,
            //   email: response.data.user.email,
            //   token: response.data.jwt,
            //   avatar: response.data.user.picture,
            //   authID: response.data.user.id,
            // });
            // reset and login done, now we give the information to the user
            // EventBus.$emit('loading-stop');
            that.isPassUpdated = true;
          }).catch((error) => {
            console.log(error);
            // error callback
            this.isSignUpButtonDisable = false;
            // let errorMessage = '';
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              if (error.response.status === 404) {
                // errorMessage = 'Your password reset link is not valid, or already used.';
              } else if (error.response.data.length > 0) {
                // errorMessage = error.response.data;
              } else {
                // errorMessage = 'There was an error';
              }
            } else if (error.request) {
              // errorMessage = 'Please check your connection'; // status 0
            } else {
              // Something happened in setting up the request that triggered an Error
              // errorMessage = error.message;
            }

            // that.$message.error({
            //   showClose: true,
            //   message: errorMessage,
            // });
          });
          that.$message.success({
            showClose: true,
            message: 'Your password has been changed successfully',
          });
          this.$router.replace('/');
        } else {
          that.isSubmitButtonLoading = false;
          that.$message.error({
            showClose: true,
            message: 'Please complete your form correctly',
          });
        }
      });
    },
  },
  computed: {
    accounts() {
      return this.$store.getters.getAccounts;
    },
  },
  components: {
    EyeOffIcon,
    EyeIcon,
  },
};
</script>

<style>
  .reset-wrapper {
    max-width: 540px;
    margin: 0 auto;
    padding: 2em 1em;
    width: 100%;
  }

  .reset {
    display: block;
    text-align: left;
  }

  .btn-eye {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
  }

  @media only screen and (min-width: 900px) {
    .reset-wrapper {
        max-width: 1300px;
        margin: 0 auto;
        padding: 3em 1em;
    }
    .reset {
      display: block;
      max-width: 585px;
      margin: 0 auto;
      position: relative;
    }
  }

  .el-form--label-top .el-form-item__label {
      padding: 0px;
  }

  .el-form-item {
      margin-bottom: 1.13em;
  }
</style>

<style scoped>
  form {
    max-width: 400px;
  }
  .el-form-item.is-required .el-form-item__label:before {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// Reset.vue?6dc100f0